export default __webpack_public_path__ + "static/media/TheinhardtPan-Light.e6adc51f.otf";